module.exports = __webpack_public_path__ + "img/dang2.c19248c4.png";